import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import MoreIcon from "@material-ui/icons/MoreHoriz";
import React from "react";
import { useTranslate } from "react-admin";

import { useOwnerCompanyDataContext } from "../../../../contexts/OwnerCompanyDataProvider";
import { OrderService, OrderServices } from "../../../../entities";
import { documentTypes } from "../../../../entities/documentTypes";
import {
	parseDateFromDatetimeString,
	parseTimeFromDatetimeString,
	utcStr2localStr,
} from "../../../_helpers/dateTime";
import { DateTimeField } from "../../DateFormatField";
import DocumentTextParsedStatus from "../../DocumentTextParsedField";
import { DocumentItemMenu } from "./DocumentItemMenu";

const useDocumentItemStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
	},
	rootGray: {
		width: "100%",
		opacity: 0.5,
	},
	media: {
		height: 140,
		backgroundPosition: "top",
	},
	contentRoot: {
		padding: theme.spacing(1),
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),

		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",

		"&:last-child": {
			paddingBottom: theme.spacing(1),
		},
	},
	title: {
		overflowWrap: "anywhere",
		textAlign: "left!important",
	},
}));

export const DocumentItem = ({ typeChoices, ...props }) => {
	const translate = useTranslate();
	const { ownerCompanyData } = useOwnerCompanyDataContext();
	const classes = useDocumentItemStyles();
	let outputDocInfo = null;
	const rootStyle = {};
	if (props.isOutputDocuments) {
		let created_by_name = "SYSTEM";
		if (props.data.created_by_name) {
			created_by_name = props.data.created_by_name;
		} else {
			rootStyle["opacity"] = 0.5;
		}

		const recreated_at = props.data.recreated_at
			? parseDateFromDatetimeString(props.data.recreated_at) +
			  " " +
			  parseTimeFromDatetimeString(props.data.recreated_at)
			: "-";

		outputDocInfo = (
			<>
				Created by: {created_by_name}
				<br />
				Auto edited: {recreated_at}
				<br />
				{props.data.is_empty ? "EMPTY" : ""}
			</>
		);
	}

	const created_at = props.data.created_at;
	const title = !props.isOutputDocuments
		? props.data.title
		: props.data.title +
		  " " +
		  parseDateFromDatetimeString(created_at) +
		  " " +
		  parseTimeFromDatetimeString(created_at);
	const currentTypeChoices = typeChoices || documentTypes;
	const docType = currentTypeChoices.find((x) => x.id === props.data.type);
	return (
		<Card className={classes.root} style={rootStyle} elevation={0} variant="outlined">
			<CardActionArea href={props.data.preview_src} target="_blank">
				<CardMedia className={classes.media} image={props.data.preview_thumbnail} />
			</CardActionArea>
			<CardContent className={classes.contentRoot}>
				<Typography className={classes.title} variant="body2" color="textSecondary" component="p">
					{docType && (
						<Typography
							className={classes.title}
							variant="body2"
							color="textPrimary"
							component="span"
						>
							{translate(docType.name, {
								company_name: ownerCompanyData.short_name,
								service_name: OrderServices[OrderService.intoPlukkStorage].short_name,
							})}
						</Typography>
					)}
					<br />
					<DateTimeField source="created_at" record={props.data} />
					<br />
					{title}
					<br />
					{outputDocInfo}
					{!props.isOutputDocuments && <DocumentTextParsedStatus {...props} />}
				</Typography>
				<DocumentItemMenu
					isReadOnly={props.isReadOnly}
					document={props.data}
					handleUpdate={props.handleUpdate}
					handleDelete={props.handleDelete}
					isOutputDocuments={props.isOutputDocuments}
					typeChoices={typeChoices}
				>
					<IconButton size="small" color="primary">
						<MoreIcon fontSize="small" />
					</IconButton>
				</DocumentItemMenu>
			</CardContent>
		</Card>
	);
};
